import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UtilityService } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { AppDataService, StaticDataService } from '../../../../services';
import { EditLayoutsDialog } from './edit-layouts.dialog';
import { ViewChartsDialog } from './view-charts.dialog';



@Injectable({ providedIn: 'root' })
export class VegaService {

	private readonly appData = inject(AppDataService);
	private readonly staticData = inject(StaticDataService);
	private readonly util = inject(UtilityService);
	private readonly router = inject(Router);
	private readonly dialogService = inject(DialogService);


	public async openDialog(dialog: 'View Charts' | 'Edit Layouts') {
		if (dialog == 'View Charts') {
			const action = await this.dialogService.showCustom(ViewChartsDialog, {}, 1000, 700);
		}
		else if (dialog == 'Edit Layouts') {
			const action = await this.dialogService.showCustom(EditLayoutsDialog, {}, 1000, 700);
		}
	}
}